module.exports = __webpack_public_path__ + "img/giftCertificate1_1.879271d6.png";